import { reportToSentry } from '@littlebird/logger/report';
import * as Sentry from '@sentry/react';

interface ErrorLogOptions {
  context?: string;
  metadata?: Record<string, unknown>;
}

export const logError = (
  error: unknown,
  message: string,
  options?: ErrorLogOptions
) => {
  // Ensure we have a proper Error object with stack trace
  let errorObject: Error;
  if (error instanceof Error) {
    errorObject = error;
  } else if (typeof error === 'string') {
    errorObject = new Error(error);
  } else if (typeof error === 'object' && error !== null) {
    // Try to preserve as much info as possible
    const message =
      (error as any).message ||
      JSON.stringify(error, Object.getOwnPropertyNames(error)) ||
      String(error);
    errorObject = new Error(message);
    // Copy enumerable properties
    Object.keys(error).forEach((key) => {
      try {
        (errorObject as any)[key] = (error as any)[key];
      } catch {
        // ignore property copy errors
      }
    });
  } else {
    errorObject = new Error(String(error));
  }

  // Preserve original error message if it wasn't an Error object
  if (!(error instanceof Error)) {
    errorObject.name = 'CapturedError';
    // Store the original non-Error value
    Object.defineProperty(errorObject, 'originalValue', {
      value: error,
      enumerable: false,
    });
  }

  // Console logging with more context
  console.error(`[${options?.context}] ${message}:`, errorObject);

  reportToSentry(Sentry, errorObject, {
    extra: {
      message,
      context: options?.context,
      metadata: options?.metadata,
      originalValue: !(error instanceof Error) ? error : undefined,
    },
    tags: {
      context: options?.context || 'unknown',
      errorType: error?.constructor?.name || typeof error,
    },
  });
};
